import React, { Fragment, useEffect, useState } from 'react';
import Header2 from '../../components/Header2/Header2';
import Hero2 from '../../components/hero2/hero2';
import Header from '../../components/header/Header';
import FeatureSection from '../../components/It-Services-Components/FeatureSection';
import About from '../../components/It-Services-Components/about/about';
import ServiceSection from '../../components/It-Services-Components/ServiceSection/ServiceSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
import BrandSection from '../../components/It-Services-Components/BrandSection/BrandSection';
import FunFactSection from '../../components/It-Services-Components/FunFact/FunFact';
import ProjectSection from '../../components/It-Services-Components/ProjectSection/ProjectSection';
import WorkProcess from '../../components/It-Services-Components/WorkProcess/WorkProcess';
import ParallaxSection from '../../components/It-Services-Components/PerallaxSection/PerallaxSection';
import Testimonial from '../../components/It-Services-Components/Testimonial/Testimonial';
import TeamSection from '../../components/It-Services-Components/TeamSection/TeamSection';
import ContactSection from '../../components/It-Services-Components/ContactSection';
import Footer from '../../components/It-Services-Components/Footer/Footer';
import sIcon5 from '../../images/bg/parallax.jpg';
import axios from 'axios';
import LoadingScreen from '../loading/loading';
import TestimonialData  from '../../components/data-solutions-components/Testimonial/Testimonial';

const HomePage2 = () => {
    const [Data, setData] = useState({});
    const [Logo, setLogo] = useState("");
    const [Favicon, setFavicon] = useState("");
    const [Title, setTitle] = useState("");
    const [Loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get('https://cms.ahmar.ir/api/v4/service?site_id=47b1ea3c09d216632db5b480db7b07ee&name=home&language_id=86a03f331955081d6d3cbcecd3b1e0f6', { headers: 'x-locale:fa' })
            .then(response => {
                console.log(response)
                const siteData = response.data.site;
                setData(response.data.data);
                setLogo(siteData.site_logos + siteData.site_logo);
                setFavicon(siteData.site_logos+siteData.fav_icon);
                setTitle(siteData.title); // دریافت مقدار title
                setLoading(true);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        if (Title) {
            document.title = Title; // تنظیم تایتل صفحه
        }
    }, [Title]);

    useEffect(() => {
        if (Favicon) {
            const link = document.querySelector("link[rel~='icon']");
            if (link) {
                link.href = Favicon;
            } else {
                const newLink = document.createElement("link");
                newLink.rel = "icon";
                newLink.href = Favicon;
                document.head.appendChild(newLink);
            }
        }
    }, [Favicon]);

    if (!Loading) {
        return (<LoadingScreen></LoadingScreen>);
    } else {
            return (
                <Fragment>
                    <div className='body_wrap it-services'>
                        {/* <Header logo={Logo} data={Data.menu_header.menu[0].all_active_menus}></Header> */}
                        <Header2 logo={Logo} data={Data.menu_header.menu[0].all_active_menus} />
                        <main className="page_content">
                            <Hero2 data={Data.home_banner.contents.data} />
                            <div className="bg-white">
                                <FeatureSection data={Data.home_under_slider.contents.data[0]} />
                                <About data={Data.home_services.contents.data} />
                            </div>
                            <ServiceSection data={Data.home_production.contents.data} />
                            <BrandSection data={Data.home_brands.contents.data[0]} />
                            {/* <FunFactSection /> */}
                            <TestimonialData  data={Data.home_weblog.contents.data}/>
                            <ProjectSection data={Data.home_portfolio.contents.data}></ProjectSection>
                            <WorkProcess data={Data.home_workflow.contents.data[0]} />
                            <ParallaxSection imageUrl={Data.home_company_picture.contents.data[0].file_path} speed={0.5} offset={0} />
                            <Testimonial data={Data.home_comments.contents.data} />
                            <TeamSection />
                            <ContactSection />
                        </main>
                        <Footer data={Data.menu_footer.menu[0].all_active_menus} about={Data.footer_about.contents.data[0]}/>
                        <Scrollbar />
                    </div>
                </Fragment>
            );
    }
};

export default HomePage2;
